import Vue, { VueConstructor } from "vue";
import { queryString } from "get-query-strings";
import { gameStore } from "@/store/game/store";
import { rootStore } from "../store";
import Keypress from "vue-keypress";

export default (Vue as VueConstructor<Vue & {}>).extend({
  data() {
    return {
      name: "",
      gid: undefined,
      clicked: false,
      error: ""
    };
  },
  computed: {
    joined() {
      return !!gameStore.state.gid;
    }
  },
  methods: {
    join() {
      if (!this.name || this.clicked) return;
      this.clicked = true;
      const p = rootStore
        .dispatchJoin({
          name: this.name,
          gid: this.gid
        });
      p.catch(r => {
        this.error = r;
      });
    }
  },
  components: {
    Keypress
  },
  mounted() {
    this.gid = queryString("gid");
  }
});